import { createSignal } from 'solid-js';

// The bundle's own version, injected at build time from the repo VERSION file
// (the SAME file the Go binary embeds). When the server reports a DIFFERENT
// value, this running bundle is stale and the PWA self-updates.
export const APP_VERSION = (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev');

const [updateAvailable, setUpdateAvailable] = createSignal(false);
export { updateAvailable };

async function fetchServerVersion() {
  try {
    const r = await fetch('/api/version', { cache: 'no-store' });
    if (!r.ok) return null;
    const d = await r.json();
    return (d && d.version) || null;
  } catch {
    return null;
  }
}

// Clear the cached app shell + refresh the service worker, then reload so the
// browser pulls the new bundle from the network.
export async function applyUpdate() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.update().catch(() => {})));
    }
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {}
  window.location.reload();
}

async function check(auto) {
  const sv = await fetchServerVersion();
  if (!sv || sv === APP_VERSION) {
    setUpdateAvailable(false);
    return;
  }
  // Any difference (not only higher) means the running bundle is stale.
  if (auto) {
    // Auto-update once per server version — the guard prevents a reload loop if
    // the refreshed bundle somehow still reads stale (e.g. offline).
    const key = 'pwaUpdated:' + sv;
    try {
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        applyUpdate();
        return;
      }
    } catch {}
  }
  setUpdateAvailable(true); // fall back to a manual "reload" banner
}

// Check on launch (auto-update — the user just opened the app) and again each
// time the app returns to the foreground (then only prompt, never interrupt).
export function startUpdateChecks() {
  check(true);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check(false);
  });
}
